// This file is auto-generated during build
export const version = '2.0.0';
